import Utils from "context/utils";

const count = (value) => value.toLocaleString("en-US");

/** A served catalog value as text, by its unit; any value or unit it cannot read comes back as plain text. */
export function formatCatalogValue(unit, value) {
  if (undefined === value) return "—";
  if (null === value) return "days" === unit ? "Forever" : "Unlimited";
  const number = "number" === typeof value && Number.isFinite(value);
  switch (unit) {
    case "count":
      if (number) return count(value);
      break;
    case "tokens":
      if (number) return `${count(value)} tokens`;
      break;
    case "bytes":
      if (number) return Utils.formatBytes(value);
      break;
    case "seconds":
      if (number) return Utils.formatDuration(value * 1000);
      break;
    case "days":
      if (number) return `${count(value)} ${1 === value ? "day" : "days"}`;
      break;
    case "flag":
      if ("boolean" === typeof value) return value ? "Yes" : "No";
      break;
    case "modules":
      if (Array.isArray(value)) return value.length ? value.join(", ") : "None";
      break;
    default:
      break;
  }
  return "object" === typeof value ? JSON.stringify(value) : String(value);
}
